import type { AidaOverlayOrigin } from '../../stores/overlay-store'
import { overlayFrameStyle } from '../../utils/overlay/overlay-animation'

export function AidaOpenShell({
  origin,
  shellRef,
}: {
  origin: AidaOverlayOrigin
  shellRef: (node: HTMLDivElement | null) => void
}) {
  return (
    <div
      ref={shellRef}
      aria-hidden
      style={overlayFrameStyle(origin)}
      className="pointer-events-none fixed overflow-hidden rounded-4 bg-theme_semantic_surface_primary-background-elevated shadow-3-smooth ring-1 ring-inset ring-theme_semantic_surface_border_color-subtle"
    />
  )
}
